import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import DataTable from "../../components/Table/DataTable";
import RegisterForm from "./../../components/RegisterForm";
import SearchBox from "./../../components/SearchBox/SearchBox";

import { getUsers } from "../../services/user";
import { showAlert } from "../../store/ducks/alert";

import { Button, CircularProgress } from "@material-ui/core";
import { Add } from "@material-ui/icons";

const Users = ({ location, match }) => {
  const dispatch = useDispatch();
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isOrdering, setIsOrdering] = useState(0);
  const [orderDirections, setOrderDirections] = useState({ item: "createdAt", direction: "DESC" });
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });


  useEffect(() => {
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchitem,
        search: match.params.search,
      });
    }
    displayUsers();
  }, [isSearching, isOrdering, page]);

  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const handleOpen = () => {
    setOpen(!open);
  };

  const headers = ["id", "email", "isAdmin", "isEnabled", "isBetaTester", "notify", "countryCode"];

  const SearchBoxHeaders = ["id", "email", "countryCode"];

  const displayUsers = async () => {
    try {
      setIsLoading(true);


      let params = { order: orderDirections.item, direction: orderDirections.direction, limit: 5 };
      if (isSearching) params = { ...searchField, ...params };

      const { data: users } = await getUsers(page, params);

      setUsers(users.rows);
      setTotalItems(users.count);
      setTotalPages(users.pages);
      setPage(users.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert("error", error.message));
    }
  };

  if (isLoading)
    return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div data-testid="users-container" className="users-container">
        <h1>Users ({totalItems})</h1>
        <div className="users-right">
          <Button
            data-testid="add-user-button"
            variant="contained"
            onClick={handleOpen}
            startIcon={<Add />}
          >
            Add User
          </Button>

          <SearchBox
            date-testid="search-box"
            selectItems={SearchBoxHeaders}
            onSubmitSearch={handleSubmitSearch}
            isSearching={isSearching}
            setIsOrdering={setIsOrdering}
          />
        </div>
      </div>

      {open ? <RegisterForm onOpen={handleOpen} /> : ""}

      <DataTable
        data-testid="users-table"
        head={headers}
        body={users}
        action={true}
        bodyColumn={headers}
        linkPath={"users"}
        totalPages={totalPages}
        currentPage={page}
        setPageChange={setPage}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
      />
    </>
  );
};

export default Users;
